import * as actions from './tailoringMaster/actions'
import * as mutations from './tailoringMaster/mutations'
import * as getters from './tailoringMaster/getters'

import { dataProps } from './tailoringMaster/properties'

const state = {
    list: [],
    nav: {
        page_number: 1,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1,
        search_term: '', 
        search_term_array: [],
        search_type: 0,
        had_results: false
    },
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringMaster.js